<template>
    <mm-tab-title v-model="tab" :titles="titles">
        <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <el-form ref="form" :model="result" size="small" label-width="120px">
        
            <div v-show="tab===1">
                <el-form-item v-if="edit" label="Offer Id" prop="offer_id" >
                    <el-input v-model.number="result.offer_id"   readonly />
                </el-form-item>
                <el-form-item label="Offer Name" prop="offer_name"  required>
                    <el-input v-model="result.offer_name" />
                </el-form-item>
                <el-form-item label="Adv Offer Id" required prop="adv_offer_id">
                    <el-input v-model.trim="result.adv_offer_id" />
                </el-form-item>
                <el-form-item label="Advertiser" required prop="adv_id">
                    <mm-adv-select no_paused v-model="result.adv_id" />
                </el-form-item>
                <el-form-item label="Manager" required prop="offer_bd">
                    <mm-users v-model="result.offer_bd"/>
                </el-form-item>
                <el-form-item label="Pid" prop="pid">
                    <el-input v-model.trim="result.pid" />
                </el-form-item>
                 <el-form-item :style="{width: trackMaxWidth ? '100%' : '700px'}" label="Tracking Link" prop="adv_tracking_link" required >
                    <el-input v-model="result.adv_tracking_link" type="textarea" class="textarea-font" :rows="6" />
                    <el-button type="primary" @click="addClickParameters()">Add Click Parameters</el-button>
                    <el-button @click="changeLabelWidth(0)">{{ trackMaxWidth ? 'Origin Width' : 'Max Width' }}</el-button>
                    <mm-notify notePath="offerEdit"></mm-notify>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :style="{width: impMaxWidth ? '100%' : '700px'}" label="Impression Link" prop="impression_link" >
                            <el-input v-model="result.impression_link" type="textarea" class="textarea-font" :rows="6" />
                            <el-button type="primary" @click="addClickParameters()">Add Click Parameters</el-button>
                            <el-button @click="changeLabelWidth(1)">{{ trackMaxWidth ? 'Origin Width' : 'Max Width' }}</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Remark" prop="remark"  >
                            <el-input v-model="result.remark" type="textarea" :rows="6" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Is Cover" prop="is_cover" >
                    <el-switch v-model="result.is_cover" />
                </el-form-item>
                <el-form-item label="Cover Interval" >
                    <el-input-number v-model="cover_interval_min" :min="0" />
                </el-form-item>
                <el-form-item label="Cover Track" prop="is_cover_app" >
                    <el-switch v-model="result.is_cover_app" />
                </el-form-item>
                <el-form-item label="Cover Track Interval" >
                    <el-input-number v-model="cover_app_interval_min" :min="0" />
                </el-form-item>
                <el-form-item label="Cover Params" prop="cover_app" >
                    <el-input v-model="result.cover_app" type="textarea" :rows="5" :placeholder="cover_app_eg"/>
                </el-form-item>

                <el-form-item label="Offer Price" prop="offer_price" required >
                    <el-input type="number" @mousewheel.native.prevent v-model="result.offer_price"/>
                </el-form-item>
                <el-form-item label="Pricing Model" prop="pricing_model" required>
                    <mm-radio v-model="result.pricing_model" :options="priceModelOptions"/>
                </el-form-item>
                <el-form-item label="Open payout" prop="open_payout" >
                    <el-switch v-model="result.open_payout" />
                </el-form-item>
                <el-form-item label="Traffic Type" prop="traffic_type" required>
                    <mm-radio v-model="result.traffic_type" :options="trafficTypeOptions"/>
                </el-form-item>
                <el-form-item label="Platform" prop="platform" required>
                    <mm-radio v-model="result.platform" :options="platformOptions"/>
                </el-form-item>
                <el-form-item label="Status" prop="status" required>
                    <mm-radio v-model="result.status" :options="statusOptions"/>
                </el-form-item>
                <el-form-item label="Manual Status" prop="manual_status" required>
                    <mm-radio v-model="result.manual_status" :options="manualStatusOptions"/>
                </el-form-item>
                <el-form-item label="Server Click" prop="server_click" >
                    <el-switch v-model="result.server_click" />
                </el-form-item>
                <el-form-item label="Category" prop="category">
                    <mm-offer-category :type="result.platform" v-model="result.category"/>
                </el-form-item>
                <el-form-item label="Current" prop="current">
					<mm-offer-currency v-model="result.currency" />
                </el-form-item>
                <el-form-item label="Geo" prop="geo" required>
                    <el-input v-model.trim="result.geo" type="textarea" :rows="2" />
                </el-form-item>
                <el-form-item label="State" prop="state">
                    <el-input v-model.trim="result.state" type="textarea" :rows="2" />
                </el-form-item>
                <el-form-item label="City" prop="city">
                    <el-input v-model.trim="result.city" type="textarea" :rows="2" />
                </el-form-item>
                <el-form-item label="Offer Kpi" prop="kpi"  >
                    <el-input v-model="result.kpi" type="textarea" :rows="5" />
                </el-form-item>
                <el-form-item label="Events" prop="events" :key="eventsDomKey">
                  <el-button size="medium" type="success" @click="addEvent">ADD</el-button>
                  <div v-for="(item, key) in result.events" :key="key" style="padding-left: 30px;">
                    <div style="padding-bottom:10px;">
                      <span style="padding-right:20px;">Event {{ key+1 }}</span>
                      <el-button size="medium" type="danger" @click="deleteEvent(key)">Delete Event {{ key+1 }}</el-button>
                    </div>
                    <el-form-item label="Event Name" label-width="100px">
                      <el-input v-model.trim="item.event_name" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Event Value" required label-width="100px">
                      <el-input v-model.trim="item.event_value" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Payout" label-width="100px">
                      <el-input type="number" @mousewheel.native.prevent v-model="item.payout" style="width:300px;"/>
                    </el-form-item>
                  </div>
                </el-form-item>
            </div>
            
            <div v-show="tab===2">
                <el-form-item label="App Name" prop="app_name">
                    <el-input v-model="result.app_name" />
                </el-form-item>
                <el-form-item label="Package Id" prop="package_id">
                    <el-input v-model.trim="result.package_id" />
                </el-form-item>
                <el-form-item label="Preview Url" prop="preview_url">
                    <el-input v-model.trim="result.preview_url" />
                </el-form-item>
                <el-form-item label="Icon Url" prop="icon">
                    <el-input v-model.trim="result.icon_addr" />
                </el-form-item>
                <el-form-item label="App Description" prop="description"  >
                    <el-input v-model="result.description" type="textarea" :rows="5" />
                </el-form-item>
                <el-form-item label="Creatives" prop="creatives"  >
                    <el-input v-model="result.creatives" type="textarea" :rows="5" />
                </el-form-item>

            </div>
            <div v-show="tab===3">
                 <el-form-item label="WhiteOnly" prop="whiteOnly" >
                    <el-switch v-model="result.whiteOnly" />
                </el-form-item>
                <el-form-item label="Daily Cap" prop="daily_cap" >
                    <el-input type="number" @mousewheel.native.prevent v-model="result.daily_cap" />
                </el-form-item>
                <el-form-item label="Daily Click" prop="daily_click" >
                    <el-input type="number" @mousewheel.native.prevent v-model="result.daily_click" />
                </el-form-item>
                <el-form-item label="Timezone" prop="timezone" >
                    <mm-time-zone v-model="result.timezone" />
                </el-form-item>
                <el-form-item label="Advance Active" prop="advanceActiveTime" >
                    <el-input v-model.trim="result.advanceActiveTime" placeholder="10 ~ 50"/>
                </el-form-item>
                <el-form-item label="To Active Time" prop="toActiveTime" >
                    <el-input v-model.trim="result.toActiveTime" placeholder="09"/>
                </el-form-item>
                <el-form-item label="To Pause Time" prop="toPauseTime" >
                    <el-input v-model.trim="result.toPauseTime" placeholder="23"/>
                </el-form-item>
                <el-form-item label="Exclude Subs" prop="exclude_sub" >
                    <el-input readonly  :value="JSON.stringify(result.exclude_sub)" type="textarea" :rows="5"/>
                </el-form-item>
            </div>
        </el-form>

    </mm-tab-title>


</template>

<script>
function mapUppercase(v){
	return {label:v.toUpperCase(),value:v}
}
function mapUppercase1(v){
	let label = v;
	label = label.slice(0,1).toUpperCase()+label.slice(1);
	return {label:label,value:v}
}
const priceModelOptions = ['cpi','cpa','cpc','cpe','cps'].map(mapUppercase);
const statusOptions = ['active','pending','paused'].map(mapUppercase1);
const manualStatusOptions = ['active','pending','paused'].map(mapUppercase1);
const trafficTypeOptions = ['non-incent','incent','uncertain'].map(mapUppercase1);
const platformOptions = [{label:'Android',value:'android'},
	{label:'IOS',value:'ios'},
	{label:'others',value:'Others'}
];
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		},
        cover_interval_min(v) {
            this.result.cover_interval = v * 60 * 1000;
        },
        cover_app_interval_min(v) {
            this.result.cover_app_interval = v * 60 * 1000;
        },
        'result.adv_tracking_link'(v) {
            this.result.adv_tracking_link = this.result.adv_tracking_link.replace(/\s/g, '');
        },
        'result.impression_link'(v) {
            this.result.impression_link = this.result.impression_link.replace(/\s/g, '');
        },
	},
	data() {
		return {
			result: {
				status: 'active',
				manual_status: 'active',
				pricing_model:'cpi',
				platform:'android',
				traffic_type:'non-incent',
                cover_interval: 0,
                cover_interval_app: 0,
                events: [],
			},
            eventsDomKey: 0,
			statusOptions,
			manualStatusOptions,
			priceModelOptions,
			platformOptions,
			trafficTypeOptions,
			file_list:[],
			tab: 1,
			titles:['Base Info','App Info','Traffic Control'],
            cover_interval_min: 0,
            cover_app_interval_min: 0,
            cover_app_eg: `name1,    name2,   name3\nxxx,      xxx,     xxx\nyyy,      yyy,     yyy`,
            impMaxWidth: 0,
            trackMaxWidth: 0,
		};
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
            if (this.result.events && this.result.events.length) {
                let flag = false;
                for (const event of this.result.events) {
                    if (!event.event_value) {
                    flag = true;
                    }
                }
                if (flag) {
                    this.$message({
                        type:'error',
                        message:'Event Value can not be empty',
                    });
                    return;
                }
            }
            if (this.result.is_cover && this.cover_interval_min < 10) {
				this.$message({
					type:'error',
					message:'Cover Interval must more than 10 min.',
				});
				return;
            }
            if (this.result.is_cover_app && this.cover_app_interval_min < 10) {
				this.$message({
					type:'error',
					message:'Cover Track Interval must more than 10 min.',
				});
				return;
            }
            if (this.result.cover_app) {
                const cover_info = this.result.cover_app.split(/\n/).filter(v => !!v).map(v => v.replace(/\s+$/, '')).map(v => v.split(/,[\t|\s]+/));
                const all_params = [];
                for (const params of cover_info) {
                    for (const param of params) {
                        if (all_params.indexOf(param) === -1) {
                            all_params.push(param);
                        } else {
                            this.$message({
                                type:'error',
                                message:`Cover Params can not add the same param: ${param}`,
                            });
                            return;
                        }
                    }
                }
            }
			const request_path = this.edit?'/offer/update':'/offer/create';
			const result = await this.$post(request_path,this.result);
			if(this.edit){
				this.loadData();
			}else{
				this.$router.push({ path: "/offerEdit",query:{id:result} });
			}
            
		},
		async loadData() {
			if (this.edit) {
				const id= this.$route.query['id'];
				const result = await this.$post('/offer/detail',{id:id});
                this.result = {
                    ...result,
                    events: result.events || [],
                }
                if (this.result.cover_interval) {
                    this.cover_interval_min = this.result.cover_interval / 60 / 1000;
                }
                if (this.result.cover_app_interval) {
                    this.cover_app_interval_min = this.result.cover_app_interval / 60 / 1000;
                }
			} else if (this.$route.query['copy_id']) {
				this.result = await this.$post('/offer/detail',{id:this.$route.query['copy_id']});
                delete this.result.offer_id;
                delete this.result.adv_offer_id;
                delete this.result._id;
                delete this.result.create_at;
                delete this.result.sync_at;
                this.result.offer_name = 'COPY_' + this.result.offer_name;
                if (this.result.cover_interval) {
                    this.cover_interval_min = this.result.cover_interval / 60 / 1000;
                }
                if (this.result.cover_app_interval) {
                    this.cover_app_interval_min = this.result.cover_app_interval / 60 / 1000;
                }
            }
		},
		async addClickParameters() {
			if (!this.result.adv_id) {
				this.$message({
					type:'error',
					message:'Adv Have Not Select',
				});
				return;
			}
			const adv = await this.$post('/advertiser/detail',{adv_id:this.result.adv_id});
			if (this.result.adv_tracking_link.indexOf(adv.click_parameters) === -1) {
				this.result.adv_tracking_link += adv.click_parameters;
			} else {
				this.$message({
					type:'error',
					message:'Can Not Add Again',
				});
			}
		},
		async addImpParameters() {
			if (!this.result.adv_id) {
				this.$message({
					type:'error',
					message:'Adv Have Not Select',
				});
				return;
			}
			const adv = await this.$post('/advertiser/detail',{adv_id:this.result.adv_id});
			if (this.result.impression_link.indexOf(adv.click_parameters) === -1) {
				this.result.impression_link += adv.click_parameters;
			} else {
				this.$message({
					type:'error',
					message:'Can Not Add Again',
				});
			}
		},
        changeLabelWidth(type) {
            if (type) {
                this.impMaxWidth = this.impMaxWidth ? 0 : 1;
            } else {
                this.trackMaxWidth = this.trackMaxWidth ? 0 : 1;
            }
        },
        addEvent() {
            this.result.events.push({
                event_name: '',
                event_value: '',
                payout: 0,
            })
            this.eventsDomKey++;
        },
        deleteEvent(index) {
            this.result.events.splice(index, 1);
            this.eventsDomKey++;
        },
	},
    
	beforeMount() {
		this.loadData();
	}
};
</script>

<style>
.custom-note-notify {
    width: 400px;
}
</style>